import * as React from "react";

export const LazyPlayers = React.lazy(() => import("../Pages/Players"));
export const LazyPlayerStatsSMP = React.lazy(() =>
  import("../Pages/PlayerStatsSMP")
);
export const LazyPlayerStatsSMPTwoYear = React.lazy(() =>
  import("../Pages/PlayerStatsSMPTwoYear")
);
export const LazyPlayerStatsHardcore = React.lazy(() =>
  import("../Pages/PlayerStatsHardcore")
);
export const LazyPlayerStatsPvP = React.lazy(() =>
  import("../Pages/PlayerStatsPvP")
);
export const LazyVillagerMarkets = React.lazy(() =>
  import("../Pages/VillagerMarkets")
);
export const LazyMarkets = React.lazy(() => import("../Pages/Markets"));
export const LazyRules = React.lazy(() => import("../Pages/Rules"));
export const LazyGuide = React.lazy(() => import("../Pages/Guide"));
export const LazyGuideHardcore = React.lazy(() =>
  import("../Pages/GuideHardcore")
);
export const LazyContact = React.lazy(() => import("../Pages/Contact"));
export const LazyMap = React.lazy(() => import("../Pages/Map"));
export const LazyFishSubmission = React.lazy(() =>
  import("../Pages/FishSubmission")
);
export const LazyVote = React.lazy(() => import("../Pages/Vote"));
export const LazyMonthlyStats = React.lazy(() =>
  import("../Pages/MonthlyStats")
);
export const LazyVerifyMagicLink = React.lazy(() =>
  import("../Pages/VerifyMagicLink")
);
export const LazyLogin = React.lazy(() => import("../Pages/Login"));
export const LazyConfirmMinecraftLink = React.lazy(() =>
  import("../Pages/ConfirmMinecraftLink")
);
export const LazyPlayerWarps = React.lazy(() =>
  import("../Pages/PlayerWarps")
);
export const LazyWarpSubmission = React.lazy(() =>
  import("../Pages/WarpSubmission")
);
export const LazyWarpDetail = React.lazy(() => import("../Pages/WarpDetail"));
export const LazySupportHome = React.lazy(() =>
  import("../Pages/SupportHome")
);
export const LazySupportTickets = React.lazy(() =>
  import("../Pages/SupportTickets")
);
export const LazySupportTicketCreate = React.lazy(() =>
  import("../Pages/SupportTicketCreate")
);
export const LazySupportAppeals = React.lazy(() =>
  import("../Pages/SupportAppeals")
);
export const LazySupportAppealCreate = React.lazy(() =>
  import("../Pages/SupportAppealCreate")
);
export const LazyTicketDetail = React.lazy(() =>
  import("../Pages/TicketDetail")
);
export const LazyBanAppealDetail = React.lazy(() =>
  import("../Pages/BanAppealDetail")
);
export const LazyAdmin = React.lazy(() => import("../Pages/Admin"));
export const LazyMyUpload = React.lazy(() => import("../Pages/MyUpload"));
export const LazySubmissions = React.lazy(() =>
  import("../Pages/Submissions")
);
export const LazyBlogMySubmissions = React.lazy(() =>
  import("../Pages/BlogMySubmissions")
);
export const LazyWarpMySubmissions = React.lazy(() =>
  import("../Pages/WarpMySubmissions")
);
export const LazyRealEstateMySubmissions = React.lazy(() =>
  import("../Pages/RealEstateMySubmissions")
);
export const LazyScreenshotMySubmissions = React.lazy(() =>
  import("../Pages/ScreenshotMySubmissions")
);
export const LazySubmissionScreenshotForm = React.lazy(() =>
  import("../Pages/SubmissionScreenshotForm")
);
export const LazyUserSubmissions = React.lazy(() =>
  import("../Pages/UserSubmissions")
);
export const LazyPixelPaintSubmission = React.lazy(() =>
  import("../Pages/PixelPaintSubmission")
);
export const LazyPixelPaintGallery = React.lazy(() =>
  import("../Pages/PixelPaintGallery")
);
export const LazyOgBuilds = React.lazy(() => import("../Pages/OgBuilds"));
export const LazyMyAccount = React.lazy(() => import("../Pages/MyAccount"));
export const LazyNoResetSmpAbout = React.lazy(() =>
  import("../Pages/NoResetSmpAbout")
);
export const LazyHcGenerationsAbout = React.lazy(() =>
  import("../Pages/HcGenerationsAbout")
);
export const LazyCreativePlotsAbout = React.lazy(() =>
  import("../Pages/CreativePlotsAbout")
);
export const LazyVanillaExperimentalAbout = React.lazy(() =>
  import("../Pages/VanillaExperimentalAbout")
);
export const LazyRealEstate = React.lazy(() => import("../Pages/RealEstate"));
export const LazyRealEstateDetail = React.lazy(() =>
  import("../Pages/RealEstateDetail")
);
export const LazyRealEstateForm = React.lazy(() =>
  import("../Pages/RealEstateForm")
);
export const LazyForumHome = React.lazy(() =>
  import("../Pages/forum/ForumHome")
);
export const LazyForumBoard = React.lazy(() =>
  import("../Pages/forum/ForumBoard")
);
export const LazyForumCategory = React.lazy(() =>
  import("../Pages/forum/ForumCategory")
);
export const LazyForumThread = React.lazy(() =>
  import("../Pages/forum/ForumThread")
);
export const LazyForumNewThread = React.lazy(() =>
  import("../Pages/forum/ForumNewThread")
);
export const LazyForumProfile = React.lazy(() =>
  import("../Pages/forum/ForumProfile")
);
export const LazyForumNotifications = React.lazy(() =>
  import("../Pages/forum/ForumNotifications")
);
export const LazyForumBoardPermissionsAdmin = React.lazy(() =>
  import("../Pages/ForumBoardPermissionsAdmin")
);
export const LazyPlayerProfile = React.lazy(() =>
  import("../Pages/PlayerProfile")
);
export const LazyMessages = React.lazy(() => import("../Pages/Messages"));
export const LazySiteMenuPage = React.lazy(() =>
  import("../Pages/SiteMenuPage")
);
export const LazyBlogIndex = React.lazy(() => import("../Pages/BlogIndex"));
export const LazyBlogPostDetail = React.lazy(() => import("../Pages/BlogPostDetail"));
export const LazySubmissionBlogForm = React.lazy(() =>
  import("../Pages/SubmissionBlogForm")
);
export const LazyTournamentsList = React.lazy(() => import("../Pages/TournamentsList"));
export const LazyTournamentCreate = React.lazy(() => import("../Pages/TournamentCreate"));
export const LazyTournamentEdit = React.lazy(() => import("../Pages/TournamentEdit"));
export const LazyTournamentDetail = React.lazy(() => import("../Pages/TournamentDetail"));
export const LazyTournamentMatch = React.lazy(() => import("../Pages/TournamentMatch"));
export const LazyCart = React.lazy(() => import("../Pages/Cart"));
export const LazyCheckout = React.lazy(() => import("../Pages/Checkout"));
export const LazyStore = React.lazy(() => import("../Pages/Store"));
